module.exports = __webpack_public_path__ + "static/029.thumb-fe9085258f25f83526f788f9c11f549b.jpg";